import React, { useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import logo from "assets/logos/iserba.png";
import IserbaAvatarViewer from "components/onboarding/iserba/IserbaAvatarViewer";
import ScrollableWrapper from "../ScollableWrapper";
import SafeScreen from "../SafeScreen";

const modalRoot =
	typeof window !== "undefined"
		? document.getElementById("modal-root") || document.body
		: null;

const IserbaModal = ({ isOpen, onClose, title, children }) => {
	useEffect(() => {
		if (!isOpen) return;

		document.body.style.overflow = "hidden";

		return () => {
			document.body.style.overflow = "";
		};
	}, [isOpen, onClose]);

	const player = useMemo(() => {
		return localStorage.getItem("player")
			? JSON.parse(localStorage.getItem("player"))
			: {};
	}, []);

	if (!isOpen || !modalRoot) return null;

	return createPortal(
		<SafeScreen>
			<div
				className="fixed inset-0 z-50 flex items-center justify-center bg-gray-500"
				aria-labelledby="modal-title"
				role="dialog"
				aria-modal="true"
			>
				{/* Background layer with filter */}
				<div
					className="absolute inset-0 z-0 "
					style={{
						backgroundImage: `url(${logo})`,
						backgroundRepeat: "repeat",
						backgroundSize: "262px 144px",
						filter:
							"grayscale(100%) brightness(0.3) contrast(1.2) opacity(0.1)",
						height: "calc(var(--vh, 1vh) * 100)",
						paddingTop: "env(safe-area-inset-top)",
						paddingBottom: "env(safe-area-inset-bottom)",
					}}
				/>

				<div
					className="relative z-10 flex flex-col items-center justify-center text-white max-h-full pb-2"
					style={{
						width: "100%",
						height: "calc(var(--vh, 1vh) * 100)",
						paddingTop: "env(safe-area-inset-top)",
					}}
				>
					<IserbaAvatarViewer player={player} />

					<div
						className="bg-white min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 max-h-[80vh] flex flex-col rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] overflow-hidden relative"
						onClick={(e) => e.stopPropagation()}
					>
						<ScrollableWrapper direction="vertical" className="flex-1">
							<div className="p-6">{children}</div>
						</ScrollableWrapper>
					</div>
				</div>
			</div>
		</SafeScreen>,
		modalRoot
	);
};

export default IserbaModal;
